import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryPluginIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19.5 9.75C19.25 9.75 19 9.77 18.75 9.82V7C18.75 6.04 17.96 5.25 17 5.25H14.18C14.23 5 14.25 4.75 14.25 4.5C14.25 2.16 12.34 0.25 9.99999 0.25C7.65999 0.25 5.74999 2.16 5.74999 4.5C5.74999 4.75 5.76999 5 5.81999 5.25H1.99999C1.03999 5.25 0.249993 6.04 0.249993 7V11.78C0.229993 12.41 1.04999 12.77 1.49999 12.34C1.91999 11.96 2.44999 11.75 2.99999 11.75C4.23999 11.75 5.24999 12.76 5.24999 14C5.24999 15.24 4.23999 16.25 2.99999 16.25C2.44999 16.25 1.91999 16.04 1.49999 15.66C1.04999 15.23 0.229993 15.59 0.249993 16.22V22C0.249993 22.96 1.03999 23.75 1.99999 23.75H7.77999C8.40999 23.77 8.76999 22.95 8.33999 22.5C8.06999 22.2 7.74999 21.7 7.74999 21C7.74999 19.76 8.75999 18.75 9.99999 18.75C11.24 18.75 12.25 19.76 12.25 21C12.25 21.7 11.93 22.2 11.66 22.5C11.22 22.95 11.59 23.77 12.22 23.75H17C17.96 23.75 18.75 22.96 18.75 22V18.18C19 18.23 19.25 18.25 19.5 18.25C21.84 18.25 23.75 16.34 23.75 14C23.75 11.66 21.84 9.75 19.5 9.75ZM19.5 16.75C19.1 16.75 18.71 16.66 18.32 16.47C17.84 16.23 17.23 16.61 17.25 17.15V22C17.25 22.14 17.14 22.25 17 22.25H13.53C13.67 21.85 13.75 21.43 13.75 21C13.75 18.93 12.07 17.25 9.99999 17.25C7.92999 17.25 6.24999 18.93 6.24999 21C6.24999 21.43 6.32999 21.85 6.46999 22.25H1.99999C1.85999 22.25 1.74999 22.14 1.74999 22V17.53C2.14999 17.67 2.56999 17.75 2.99999 17.75C5.06999 17.75 6.74999 16.07 6.74999 14C6.74999 11.93 5.06999 10.25 2.99999 10.25C2.56999 10.25 2.14999 10.33 1.74999 10.47V7C1.74999 6.86 1.85999 6.75 1.99999 6.75H6.84999C7.37999 6.77 7.76999 6.15 7.52999 5.68C7.34999 5.3 7.24999 4.9 7.24999 4.5C7.24999 2.98 8.47999 1.75 9.99999 1.75C11.52 1.75 12.75 2.98 12.75 4.5C12.75 4.9 12.66 5.29 12.47 5.68C12.23 6.16 12.61 6.77 13.15 6.75H17C17.14 6.75 17.25 6.86 17.25 7V10.85C17.23 11.38 17.85 11.77 18.32 11.53C18.7 11.35 19.1 11.25 19.5 11.25C21.02 11.25 22.25 12.48 22.25 14C22.25 15.52 21.02 16.75 19.5 16.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryPluginIcon.displayName = 'LibraryPluginIcon';
